import { render, staticRenderFns } from "./royaltymeSetting.vue?vue&type=template&id=61fd714d"
import script from "./royaltymeSetting.vue?vue&type=script&lang=js"
export * from "./royaltymeSetting.vue?vue&type=script&lang=js"
import style0 from "./royaltymeSetting.vue?vue&type=style&index=0&id=61fd714d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports